export default __webpack_public_path__ + "static/small-business-economy-accomplishment-1c-5b6851b07601aa0d222d039d77ed2aa4.webp";